import React from 'react'

import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Gallery from '../../../../components/presentation/gallery/Gallery'
import Markdown from '../../../../components/presentation/Markdown'
import Panel from '../../../../components/structure/Panel'
import RecordId from '../../../../components/presentation/RecordId'
import ReplyInput from './ReplyInput'
import ReplyParentName from './ReplyParentName'
import Separator from '../../../../components/helpers/Separator'
import { Relative } from '../../../../packages/kiti/components/helpers/Position'
import { COLORS } from '@btime/constants'
import { SmallText, Text } from '../../../../components/presentation/Text'

const ReplyPanel = React.memo(({ reply, replies, allReplies, props }) => {
  const type = reply.question?.type?.name
  const name = reply.question?.name
  const description = reply.question?.description
  const documents = reply.question?.documents
  const parentName = reply?.parentName
  const allowOnlyQrCode = reply?.question?.data?.allowOnlyQrCode

  return (
    <Relative zIndex="auto">
      <Panel lineBorder mediumPadding noMargin>
        <FlexGrid justify="space-between" wrap gutter={0.3}>
          <FlexCol flex={1} wrapOn="sm" widthOnSm="100%" orderOnSmall="3">
            <RecordId labelPrefix="QUESTION_ID" record={reply.question} />
            <ReplyParentName parentName={parentName} />
            <Separator weight={2} />
            <Text bold size="h6">
              {name}
            </Text>
            {allowOnlyQrCode && <SmallText color={COLORS.red}>* Responda essa pergunta pelo app</SmallText>}
            {reply.divergent && (
              <SmallText color={COLORS.orange}>
                As atividades selecionadas têm respostas diferentes para essa pergunta. Deixe em branco para manter
                a resposta atual de cada atividade, ou preencha para substituir em todas.
              </SmallText>
            )}
          </FlexCol>
        </FlexGrid>
        {!!description && <Markdown>{description}</Markdown>}
        {!!documents?.length && (
          <>
            <Separator weight={2} />
            <Gallery items={documents} thumbHeight="3rem" colWidth="10%" widthOnSm="20%" gap={0.4} />
          </>
        )}
        {type !== 'informative' && <Separator weight={4} />}
        <ReplyInput reply={reply} replies={replies} allReplies={allReplies} {...props} />
      </Panel>
    </Relative>
  )
})

const Wrapper = ({ reply, replies, allReplies, props }) => {
  if (!reply.shouldRender) return false

  return <ReplyPanel reply={reply} replies={replies} allReplies={allReplies} {...props} />
}

export default Wrapper
